import { render, staticRenderFns } from "./IconTagSolid.vue?vue&type=template&id=3716cb78"
import script from "./IconTagSolid.vue?vue&type=script&lang=js"
export * from "./IconTagSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports